<template>
  <BasePaymentRequestsTable
    v-model:filters="defaultFilters"
    :query="query"
    :quick-filters="['statuses', 'hireOwners']"
    data-test="client-payment-requests-table"
    :search-placeholder="$t('Search name, hire title, ID...')"
  >
    <template #action="{ row }">
      <PaymentRequestActionColumn :row="row" />
    </template>
  </BasePaymentRequestsTable>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { TypedQueryDocumentNode } from 'graphql/index'
import BasePaymentRequestsTable from './BasePaymentRequestsTable.vue'
import { graphql } from '@/gql'
import { PaymentRequestStatus } from '@/gql/graphql'
import PaymentRequestActionColumn from '@/components/GraphqlDataTable/columns/PaymentRequest/Client/PaymentRequestActionColumn.vue'
import { $t } from '@/composables/translation'

const defaultFilters = ref<Record<string, any>>({
  statuses: [PaymentRequestStatus.Unapproved],
})

const query = graphql(`
  query ClientPaymentRequestsQuery(
    $accounts: [ID!]
    $search: String
    $first: Int!
    $page: Int
    $orderBy: [PaymentRequestOrderByClauseInput!]
    $statuses: [PaymentRequestStatus!]
    $requestTypes: [PaymentRequestType!]
    $workerPayoutStatuses: [PaymentRequestWorkerPayoutStatus!]
    $hasTimesheet: Boolean
    $hasPurchaseOrderNumber: Boolean
    $rateTypes: [RateType!]
    $requestedDateRange: DateRangeInput
    $billingStartDateRange: DateRangeInput
    $billingEndDateRange: DateRangeInput
    $hireOwners: [ID!]
  ) {
    paymentRequests(
      accounts: $accounts
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
      statuses: $statuses
      requestTypes: $requestTypes
      workerPayoutStatuses: $workerPayoutStatuses
      hasTimesheet: $hasTimesheet
      hasPurchaseOrderNumber: $hasPurchaseOrderNumber
      rateTypes: $rateTypes
      requestedDateRange: $requestedDateRange
      billingStartDateRange: $billingStartDateRange
      billingEndDateRange: $billingEndDateRange
      hireOwners: $hireOwners
      viewerRole: PAYER
    ) {
      data {
        ...PaymentRequestRequestedAtColumn
        ...PaymentRequestStatusIdColumn
        ...PaymentRequestWorkerColumnClient
        ...PaymentRequestHireColumnClient
        ...PaymentRequestHireOwnersColumn
        ...PaymentRequestPoNumberColumn
        ...PaymentRequestTypeColumn
        ...PaymentRequestDetailsColumn
        ...PaymentRequestBillingStartDateColumn
        ...PaymentRequestBillingEndDateColumn
        ...PaymentRequestRateColumnClient
        ...PaymentRequestUnitsColumnClient
        ...PaymentRequestWorkerPayoutStatusColumn
        ...PaymentRequestTotalAmountColumn
        ...PaymentRequestInvoiceColumn
        ...PaymentRequestActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode
</script>
